import { render } from "./MainSidebar.vue?vue&type=template&id=3268f1b9&scoped=true&ts=true"
import script from "./MainSidebar.vue?vue&type=script&lang=ts"
export * from "./MainSidebar.vue?vue&type=script&lang=ts"

import "./MainSidebar.vue?vue&type=style&index=0&id=3268f1b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3268f1b9"]])

export default __exports__